import { ComponentType } from 'react';
import WhyScale from 'react-scale/components/pages/homepage/why-scale';
import ApplyAI from 'react-scale/components/pages/homepage/apply-ai';
import BuildAI from 'react-scale/components/pages/homepage/build-ai';
import { CTASimpleCentered, Footer, Header, HeroSimpleCentered, CTA } from 'react-scale/components';
import { HorizontalLine } from 'react-scale/components/pages/homepage/dashed-line';

type CodeComponent = {
  name: string;
  importPath: string;
  component: ComponentType<any>;
  props?: Record<
    string,
    'string' | 'object' | 'number' | 'boolean' | 'code' | 'choice' | 'fields' | any
  >;
  isDefaultExport?: boolean;
  displayName?: string;
  importName?: string;
};

export const CODE_COMPONENTS: CodeComponent[] = [
  {
    name: 'CTA',
    component: CTA,
    importPath: 'react-scale/components',
    props: {
      cta: {
        type: 'object',
        fields: {
          hubspotModal: {
            type: 'object',
            fields: {
              formId: 'string',
              label: 'string',
              type: 'string',
              variant: 'string'
            }
          },
          buttons: {
            type: 'array',
            itemType: {
              type: 'object',
              fields: {
                text: 'string',
                href: 'string',
                type: 'string',
                variant: 'string'
              }
            }
          }
        }
      },
      size: 'string'
    }
  },
  {
    name: 'HeroSimpleCentered',
    component: HeroSimpleCentered,
    props: {
      title: 'string',
      subtitle: 'string',
      webgl: 'boolean',
      className: 'string'
    },
    importPath: 'react-scale/components'
  },
  {
    name: 'Header',
    component: Header,
    props: {
      theme: 'string',
      background: 'string',
      demoMode: 'boolean',
      noIndex: 'boolean',
      border: 'boolean'
    },
    importPath: 'react-scale/components'
  },
  {
    name: 'Footer',
    component: Footer,
    props: {
      theme: 'string',
      border: 'boolean'
    },
    importPath: 'react-scale/components'
  },
  {
    name: 'WhyScale',
    importPath: 'react-scale/components/pages/homepage/why-scale',
    component: WhyScale,
    isDefaultExport: true
  },
  {
    name: 'BuildAI',
    component: BuildAI,
    importPath: 'react-scale/components/pages/homepage/build-ai',
    isDefaultExport: true
  },
  {
    name: 'ApplyAI',
    component: ApplyAI,
    importPath: 'react-scale/components/pages/homepage/apply-ai',
    isDefaultExport: true
  },
  {
    name: 'CTASimpleCentered',
    component: CTASimpleCentered,
    importPath: 'react-scale/components',
    props: {
      title: 'string',
      themeColors: 'object',
      cta: 'object'
    }
  },
  {
    name: 'HorizontalLine',
    displayName: 'Divider (HorizontalLine)',
    component: HorizontalLine,
    importPath: 'react-scale/components/pages/homepage/dashed-line'
  }
];
